module.exports = __webpack_public_path__ + "img/41b-config-formularios-checklist.2b107337.png";